import React, { useEffect, useState } from 'react';
import MainContainer from '../../../components/MainContainer';
import { headerDataImmo } from '../../../data/modules/logistic-header';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import Message from '../../tools/Message';
import Title from '../../../components/Title';
import Spacer from '../../../components/Spacer';
import { DataGrid } from '@material-ui/data-grid';
import { Box, makeStyles } from '@material-ui/core';
import DescriptionIcon from '@mui/icons-material/Description';
import MissionOrderService from '../../../services/MissionOrderService';
import { Autocomplete, Button, FormControl, Grid, Paper, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import VehicleService from '../../../services/VehicleService';

const useStyles = makeStyles((theme) => ({
    paper: {
      padding: theme.spacing(2),
      display: "flex",
      overflow: "auto",
      flexDirection: "column",
      elevation: 0,
    },
  }));

const DriverOM = () => {
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
    const [rows, setRows] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [drivers, setDrivers] = useState([]); 
    const [references, setReferences] = useState([]);
    const [filter, setFilter] = useState({
        reference: '',
        destination: '',
        debut: '',
        fin: '',
        status: '',
        title: '',
        vehicle: '',
        driver: '',
    });  
    const [message, setMessage] = useState({
        open: false,
        color: 'green',
        messageInfo: '',
    });
    const classes = useStyles();

    const { open, color, messageInfo } = message;

    function handleCloseMessage() {
        setMessage({ ...message, open: false });
    }

    useEffect(() => {
      async function fetchDrivers() {
        setOpenLoadingSimpleBackdrop(true);
        try {
          const result = await VehicleService.getDriversMission();
          if (result?.data) {
            setDrivers(result.data);
          }
        } catch (error) {
          console.error("Error fetching drivers:", error);
        } finally {
          setOpenLoadingSimpleBackdrop(false);
        }
      }

      async function fetchMissions() {
        setOpenLoadingSimpleBackdrop(true);
        MissionOrderService.driversMissionsPlanning()
            .then((result) => {
              setReferences(result.data.map((data) => data.reference));
                setRows(
                    result.data.map((data, index) => {
                        return {
                            id: index,
                           ...data,
                        };
                    }
                    )
                );
            })
            .catch((error) => {
                console.error('Error:', error);
            })
            .finally(() => {
                setOpenLoadingSimpleBackdrop(false);
            });
    }

    const fetchVehicles = async () => {
      VehicleService.getAllVehicles().then((result) => {
        if (result && result.data) {
         setVehicles(result.data);
        }
      });
    };

    fetchVehicles();
    fetchDrivers();
    fetchMissions();
    }, []);

    const handleGenerateOM = async (mission_planning_id, driver_id, voiture_id, agenda_id) => {
  
        setOpenLoadingSimpleBackdrop(true);
                try {
                    const response = await MissionOrderService.generateOMDriver(mission_planning_id, driver_id, voiture_id, agenda_id);
                    // Ensure the response is a blob
                    const blob = await response.data;
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;
                    a.download = `OM.pdf`; 
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    setMessage({ open: true, color: 'green', messageInfo: 'Ordre de mission généré avec succès' });
                } catch (error) {
                    console.error('Erreur lors du téléchargement du PDF :', error);
                    setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors de la génération de l\'ordre de mission' });
                } finally {
                    setOpenLoadingSimpleBackdrop(false);
                }
        }

    const columns = [
        { field: 'reference', headerName: 'Réference', width: 150, },
        { field: 'mission_title', headerName: 'Objet de la mission', width: 360, },
        { field: 'destinations', headerName: 'destinations', width: 180, },
        { field: 'driver_name', headerName: 'Chauffeur', width: 220},
        { field: 'vhc_imm', headerName: 'Voiture', width: 220},
        { field: 'date_end', headerName: 'Date de fin', width: 160, renderCell: (params) => {
            return (
              <>
                {new Date(params.row.date_end).toLocaleDateString()}
              </>
            );
          }
          },
        { field: 'date_begin', headerName: 'Date de début', width: 180, renderCell: (params) => {
          return (
            <>
              {new Date(params.row.date_begin).toLocaleDateString()}
            </>
          );
        }
        },
        { field: 'action', headerName: 'Action',   renderCell: (params) => {
          return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                 
                    <Button title="Générer l'ordre de mission" onClick={() => handleGenerateOM(params.row.mission_planning_id, params.row.driver_id, params.row.vhc_id, params.row.mission_planning_agenda_id)} size='small' variant="outlined" 
                      color='info'
                      >
                  <DescriptionIcon  /> <strong  >OM</strong>     
                    </Button>    
            </div>
          );
        }, width: 121, },
      ];

      const handleChangeFilter = (e) => {
        const { name, value } = e.target;
        setFilter({ ...filter, [name]: value });
      }

      const handleFilter = () => {
        setOpenLoadingSimpleBackdrop(true);
        MissionOrderService.filterMissionValidated(filter).then((result) => {
          if (result && result.data) {
            setRows(result.data?.map((row) => ({ ...row, id: row.mission_planning_id })));
            setOpenLoadingSimpleBackdrop(false);
          } else {
            setOpenLoadingSimpleBackdrop(false);
          }
        });
      }

      const handleChangeAutocomplete = (event, name, value) => {
        event.preventDefault();
        setFilter({ ...filter, [name]: name == "vehicle" ? value.vhc_id : value.user_id })
      };
  

    return (
            <MainContainer {...headerDataImmo}>
        
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
        <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ my: 2 }}>
        
        <Grid container xs={12} spacing={4} justifyContent={"flex-end"} >
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            className={classes.btn}
          >
            <SearchIcon style={{ marginRight: '8px' }} />
            Filtrer
          </Button>
        </Grid>
      </Box>

      <Grid container xs={12} spacing={2} >
      <Grid item xs={12} sm={6} md={3}>
          
          <label className={classes.labelPosition}>Réference:</label>
        <FormControl fullWidth variant="outlined" size="small">
          <Autocomplete
                                      id="tags-outlined"
                                      options={references}
                                      sx={{
                                        '& .MuiInputBase-root': { height: 40 }, 
                                        '& .MuiInputBase-input': { padding: '4px 8px' } 
                                      }}
                                      getOptionLabel={(option) =>
                                        `${option}`
                                      }
                                      filterSelectedOptions
                                      onChange={(event, newValue) => {
                                        setFilter({ ...filter, reference: newValue });
                                      }
                                      }
                                      size='small'
                                      value={filter.reference}
                                      renderInput={(params) => (
                                        <TextField {...params} variant="outlined" size="small" />
                                      )}
                                    />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
          Objet de la mission :
          <TextField
            fullWidth
            id="title"
            size="small"
            variant="outlined"
            value={filter.title}
            name="title"
          onChange={handleChangeFilter}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          Destination :
          <TextField
            fullWidth
            id="destination"
            size="small"
            variant="outlined"
            value={filter.destination}
            name="destination"
          onChange={handleChangeFilter}
          />
        </Grid>
         <Grid item xs={12} sm={6} md={3}>
                  Chauffeur :
                  <Autocomplete id="tags-outlined"
                        options={drivers}
                        getOptionLabel={(option) => (option ?  option.name : '')}
                        filterSelectedOptions
                        sx={{
                          '& .MuiInputBase-root': { height: 40 }, 
                          '& .MuiInputBase-input': { padding: '4px 8px' } 
                        }}
                        onChange={(event, value) => handleChangeAutocomplete(event, "driver", value)}
                        value={ drivers.find(driver => driver.user_id == filter.driver)}
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            id="outlined-basic"
                            size="small"
                            variant="outlined"
                            label="Chauffeur"
                          />
                        )}
                      />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
          Voiture :
          <Autocomplete
                            id="tags-outlined"
                            options={vehicles || []}
                            sx={{
                              '& .MuiInputBase-root': { height: 40 }, 
                              '& .MuiInputBase-input': { padding: '4px 8px' } 
                            }}
                            getOptionLabel={(option) =>
                              `${option?.vhc_imm} (${option?.vhc_type})` || ''
                            }
                          
                            onChange={(event, newValue) => handleChangeAutocomplete(event, "vehicle", newValue) }
                            size='small'
                            value={vehicles.find((vehicle) => vehicle.vhc_id == filter.vehicle)}
                            renderInput={(params) => (
                              <TextField {...params} variant="outlined" size="small" />
                            )}
                            
                          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          Date début:
          <TextField
            fullWidth
            id="date_debut"
            size="small"
            variant="outlined"
            type="date"
            value={filter.debut}
            name="debut"
          onChange={handleChangeFilter}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          Date fin:
          <TextField
            fullWidth
            id="date_fin"
            size="small"
            variant="outlined"
            type="date"
            value={filter.fin}
            name="fin"
          onChange={handleChangeFilter}
          />
        </Grid>

      </Grid>

      <Spacer y={2} />
        <Grid container spacing={3}>
        <Grid item xs={12}>
        <Paper className={classes.paper} variant="outlined">
        <Title>Ordre des missions chauffeur</Title>
        <Spacer y={2} />
        <div style={{ height: 500, width: '100%' }}>
          <DataGrid rows={rows} columns={columns} 
           pageSize={7}
           rowsPerPageOptions={[10, 20, 50]}
          disableSelectionOnClick/>
        </div>
        </Paper>
        </Grid>
        </Grid>
        </MainContainer>
    );
};

export default DriverOM;